import { useMemo } from 'react';
import { useAppSelector, imageMaskingState } from 'src/store';

export const useImageMaskingIsEditingMode = () => {
  const { isEditingMode } = useAppSelector(imageMaskingState);

  return useMemo(
    () => ({
      isEditingMode,
    }),
    [isEditingMode],
  );
};
